import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { cartLineQuantityStyles } from "@insite/content-library/Widgets/Cart/CartLineQuantity";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

Object.assign(cartLineQuantityStyles, {
    readOnlyQuantityText: {
        extendedStyles: {
            heading: {
                css: css`
                ${({ theme }) =>
                    breakpointValuesMediaQueries(
                        theme,
                        [{ values: [null, null, "none", null, null], properties: ["display"] }],
                        mediaOptions.min,
                    )}
                `,
            },
            text: {
                css: css`
                    width: 100%;
                    padding-left: 10px;
                    font-size: 16px;
                    ${wrapInContainerStyles}
                `,
            },
        },
    },
});
